export default "__VITE_ASSET__06f987f6__"